<template>
  <div class="search-content">
    <van-pull-refresh v-model="state.refreshing" @refresh="onRefresh">
      <van-list
        v-model:loading="state.loading"
        :finished="state.finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <ul
          v-for="(item, i) in state.recordList"
          :key="i + '-list'"
          :border="false"
          v-show="state.showRecord"
        >
          <van-sticky>
            <p class="month-key" @click="state.pickTimeFlag = true">
              {{ item.key }}
              <img src="@/assets/homepage/icon_sdkRecord_unfold.png" alt="" />
            </p>
          </van-sticky>
          <li
            v-for="(item2, index) in item.items"
            :class="state.detailList.has(i + '' + index) ? 'record_detail' : ''"
            @click="changeDetail(i, index)"
          >
            <div class="title">
              <span>{{ item2.other }}</span>
              <span>¥{{ item2.amount }}</span>
            </div>
            <div>
              {{ item2.time }}
              <span>{{ item2.paytype }}支付</span>
            </div>
            <div>
              <p>
                <span>订单原价：</span><span>{{ item2.money }}</span>
              </p>
              <p>
                <span>游戏折扣：</span><span>{{ item2.discount * 10 }}折</span>
              </p>
              <p>
                <span>赠送余额抵扣：</span><span>-{{ item2.give_money }}</span>
              </p>
              <p>
                <span>优惠券:</span> <span>-{{ item2.coupon_money }}</span>
              </p>
            </div>
          </li>
        </ul>
      </van-list>
    </van-pull-refresh>
  </div>

  <van-popup v-model:show="state.pickTimeFlag" round position="bottom">
    <div class="pick_time">
      <van-datetime-picker
        v-model="state.currentDate"
        type="year-month"
        title="选择年月日"
        :min-date="state.minDate"
        :max-date="state.maxDate"
        @confirm="confirmData"
        @cancel="state.pickTimeFlag = false"
      />
    </div>
  </van-popup>
</template>
<script setup>
import { useRouter } from "vue-router";
import { reactive, onMounted, computed, ref } from "vue";
import { useStore } from "vuex";
import { monthCardBill } from "@/api/yzuser.js";
import { getQueryString } from "@/utils/location.js";
import { Toast } from "vant";

const router = useRouter();
const store = useStore();
const state = reactive({
  pickTimeFlag: false,
  hideFlag: false,
  loading: false,
  finished: false,
  refreshing: true,
  showRecord: true,

  dataMonth: [],
  recordList: [],
  selectList: [],

  detailList: new Set(),
  currentDate: new Date(),
  maxDate: new Date(),
  minDate: new Date(new Date().setMonth(new Date().getMonth() - 6)),
  selectTime: "",
  gid: "",
  gamename: "",
});

onMounted(() => {
  // console.log("进入游戏充值账单页面----", state.maxDate, state.minDate);
});

const onLoad = async () => {
  await getBill();
};

var pagecode = 1;
var totalpage = 1;
const getBill = async () => {
  state.refreshing && (state.loading = false);
  await monthCardBill({
    uid: getQueryString("uid"),
    pagecode: pagecode,
    time: state.selectTime,
    gid: getQueryString("gid"),
  }).then((res) => {
    state.refreshing && (state.refreshing = false);
    if (res.data.code == 1) {
      const monthList = res.data.data.lists;
      const groupedArray = processBillData(monthList);

      // // 合并旧数据和新数据
      state.recordList = mergeRecordLists(state.recordList, groupedArray);
      // console.log("账单数据------", state.recordList);
      totalpage = res.data.data.total_page;
      if (pagecode > res.data.data.total_page) {
        state.finished = true;
        return;
      }
      state.loading = false;
    } else {
      Toast(res.data.msg);
      state.finished = true;
    }
  });
  pagecode++;
};

const onRefresh = () => {
  state.selectTime = "";
  state.gid = "";
  state.gamename = "";
  initRecord();
  state.refreshing = true;
  state.loading = false;
  state.selectList = [];
  onLoad();
};

const confirmData = async () => {
  state.selectTime = "";
  state.gid = "";
  state.pickTimeFlag = false;
  initRecord();
  const date = new Date(state.currentDate);
  const year = date.getFullYear();
  const month = date.getMonth() + 1; // 月份从0开始，所以需要加1

  state.selectTime = `${year}-${month}`;
  await getBill();
};
// 初始化账单数据
const initRecord = () => {
  pagecode = 1;
  state.recordList = [];
  state.finished = false;
};

// 展开账单
const changeDetail = (i, index) => {
  // console.log("展开账单", i + "" + index);
  let data = i + "" + index;
  if (state.detailList.has(data)) {
    state.detailList.delete(data);
  } else {
    state.detailList.add(data);
  }
};

// 数据按月分组
const processBillData = (billData) => {
  // 分组逻辑
  const groupDate = billData.reduce((groups, item) => {
    const date = new Date(item.create_time * 1000);
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const ym = `${year}年${month}月`;

    // 初始化分组
    if (!groups[ym]) {
      groups[ym] = [];
    }
    groups[ym].push(item);

    return groups;
  }, {});

  // 转换为数组
  return Object.keys(groupDate).map((key) => ({
    key,
    items: groupDate[key],
  }));
};

// 合并数据
const mergeRecordLists = (existingList, newList) => {
  const recordMap = new Map();

  // 将现有的列表存入 Map，使用 key 作为索引
  existingList.forEach((group) => {
    recordMap.set(group.key, [...group.items]);
  });

  // 合并新的列表
  newList.forEach((group) => {
    if (recordMap.has(group.key)) {
      recordMap.set(group.key, recordMap.get(group.key).concat(group.items));
    } else {
      recordMap.set(group.key, [...group.items]);
    }
  });

  // 将 Map 转换为数组
  return Array.from(recordMap.entries()).map(([key, items]) => ({
    key,
    items,
  }));
};
</script>

<style scoped="scoped">
:deep(.van-nav-bar) {
  background-color: #f7f8fa;
}
/* #content {
  background-color: #f7f8fa;
  height: 100vh;
  overflow: hidden;
  padding: 90px 0 50px;
  padding-top: calc(90px + constant(safe-area-inset-top));
  padding-top: calc(90px + env(safe-area-inset-top));
} */
.search-content {
  width: 100vw;
  height: 100vh;
  overflow: auto;
  padding: 20px 32px 200px;
  background-color: #161b1f;
  padding-top: 20px;
}
:deep(.van-pull-refresh) {
  overflow: visible;
}
ul .month-key {
  color: #fff;
  margin-bottom: 18px;
  font-weight: 700;
  background-color: #161b1f;
}
ul :deep(.van-sticky--fixed) {
  height: 100px !important;
  top: 20px;
}
ul .month-key {
  height: 100%;
  display: flex;
  align-items: center;
}
ul .month-key img {
  width: 18px;
  height: 11px;
  vertical-align: middle;
  margin: 0 0 4px 8px;
}

ul li {
  height: 120px;
  overflow: hidden;
  box-sizing: border-box;
  margin-bottom: 16px;
  background-color: #283138;
  border-radius: 20px;
  padding: 24px;
  transition: all 0.5s ease;
}
.record_detail {
  height: 328px;
}

ul li div {
  display: flex;
  justify-content: space-between;
}

ul li .title {
  font-weight: 500;
  font-size: 28px;
  color: #fff;
}

ul div:nth-of-type(3) {
  flex-direction: column;
  background-color: #3f4951;
}

ul div:nth-of-type(2) {
  margin-bottom: 24px;
  font-size: 24px;
  color: #fff;
}

ul div:nth-of-type(3) {
  padding: 20px;
  border-radius: 10px;
}

ul div:nth-of-type(3) p {
  display: flex;
  justify-content: space-between;
  font-size: 24px;
  color: #fff;
}

ul div:nth-of-type(3) p:nth-of-type(1) span:nth-of-type(2) {
  color: #ff6666;
}

/* 时间选择器样式 */
:deep(.van-picker),
:deep(.van-picker__confirm),
:deep(.van-picker__cancel),
:deep(.van-picker-column__item) {
  background-color: #283138;
  color: #fff;
}

:deep(.van-picker__mask) {
  background: none;
}
</style>
